import React from 'react'

import {Provider} from 'react-redux'

import {makeStore} from '../redux/store'

const store = makeStore()

if (process.env.NODE_ENV !== 'production') {
  // Expose the dev store to the window for debugging
  window.store = store
}

export default function StoreProvider({children}: {children: React.ReactNode}) {
  return <Provider store={store}>{children}</Provider>
}
